import React from 'react';
import InputMask from 'react-input-mask';

import InputBase from 'apps/auth/components/form-multi/InputBase';
import { inputPropType } from 'apps/auth/helpers/customPropTypes';
import { getInputMode, getPlaceholderRule, getSeparatorsCount, isMaskPattern, padMaskPattern } from 'apps/auth/helpers/fieldMask';

const InputBik = (props) => {
    const field = props.field;
    if (field.value === null) {
        field.value = '';
    }

    const hasMaxLength = props.setMaxLength && field.maxLength;

    if (isMaskPattern(field.mask)) {
        const separatorsCount = hasMaxLength ? getSeparatorsCount(field.value, field.mask) : 0;
        return (
            <InputMask
                mask={padMaskPattern(field.mask)}
                maskChar={null}
                formatChars={{ '#': getPlaceholderRule(field.mask, field.checkRegexp) }}
                id={field.name}
                name={field.canonicalPath ? field.canonicalPath : field.name}
                value={field.value || ''}
                type="text"
                className={props.isNewInput ? null : 'field field-duo'}
                autoComplete="off"
                readOnly={field.isReadOnly || false}
                autoFocus={props.focus}
                onFocus={props.onFocus}
                onChange={props.onChange}
                onBlur={props.onBlur}
            >
                {(inputProps) => (
                    <input
                        {...inputProps}
                        maxLength={hasMaxLength ? +field.maxLength + separatorsCount : null}
                        inputMode={getInputMode(field.checkRegexp, field.mask)}
                    />
                )}
            </InputMask>
        );
    }

    return (
        <input
            id={field.name}
            maxLength={hasMaxLength ? field.maxLength : ''}
            name={field.canonicalPath ? field.canonicalPath : field.name}
            value={field.value || ''}
            type="text"
            inputMode={getInputMode(field.checkRegexp, field.mask)}
            readOnly={field.isReadOnly || false}
            className={props.isNewInput ? null : 'field field-duo'}
            autoComplete="off"
            autoFocus={props.focus}
            onFocus={props.onFocus}
            onChange={props.onChange}
            onBlur={props.onBlur}
        />
    );
};

InputBik.propTypes = inputPropType(['bik']);

export default InputBase(InputBik, false);
